import React, { Component } from 'react';
import { connect } from 'react-redux';
import { alerts } from '../actions/alerts';
import CONSTANTS from "../constants";

class Alert extends Component {

	constructor(props) {
		super(props);
		this.onClear = this.onClear.bind(this);
	}
	
	onClear() {
		this.props.dispatch(alerts.clear());
	}
	
	render () {
		const { alert } = this.props;
		if(alert.type && alert.message) {
			setTimeout(this.onClear, CONSTANTS.ALERTS.DURATION);
			return (
				<div className="alert-message">
					<div className={`alert fade in text-center ${alert.type}`}>
						<button type="button" className="close" aria-label="Close" onClick={this.onClear}>
							<span aria-hidden="true">&times;</span>
						</button>
						<div>{alert.message}</div>
					</div>
				</div>
			);
		} else {
			return '';
		}
	}
}

function mapStateToProps(state) {
	const { alert } = state;
	return {
		alert
	};
}

export default connect(mapStateToProps)(Alert);



// WEBPACK FOOTER //
// ./src/components/alert.js